// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3TZty","location":"Header_location__9bUVi"};